export default {
  GET_THE_APP: 'Get the App',
  MAKE_FLOCK_BETTER_APPS: 'Make Flock even better with apps',
  URL_APP_DECORATOR_NO_PROMPT_TEXT:
    "Ok , we won't prompt app suggestions for {appOrDomain}.Visit the {flockStore} to discover apps.",
  FLOCK_APP_STORE: 'Flock App Store',
};
